import { Loader2, AlertTriangle, CheckCircle2, Clock } from "lucide-react";
import { STATUS_LABEL, useApp } from "@/lib/i18n";

const STYLE = {
  bot_scheduled: ["bg-amber-50 text-amber-800", Clock],
  bot_joining: ["bg-sky-50 text-sky-700", Loader2],
  bot_recording: ["bg-rose-50 text-rose-700", Loader2],
  bot_processing: ["bg-sky-50 text-sky-700", Loader2],
  queued: ["bg-slate-100 text-slate-700", Clock],
  preparing_audio: ["bg-sky-50 text-sky-700", Loader2],
  transcribing: ["bg-violet-50 text-violet-700", Loader2],
  polishing: ["bg-fuchsia-50 text-fuchsia-700", Loader2],
  generating_notes: ["bg-indigo-50 text-indigo-700", Loader2],
  completed: ["bg-emerald-50 text-emerald-700", CheckCircle2],
  failed: ["bg-red-50 text-red-700", AlertTriangle],
};

export const StatusBadge = ({ status }) => {
  const { L } = useApp();
  const [cls, Icon] = STYLE[status] || STYLE.queued;
  const [ms, en] = STATUS_LABEL[status] || STATUS_LABEL.queued;
  return (
    <span data-testid="meeting-status-badge" data-status={status} className={`inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-xs font-semibold ${cls}`}>
      <Icon size={12} className={Icon === Loader2 ? "animate-spin" : ""} /> {L(ms, en)}
    </span>
  );
};

export const PageHeader = ({ title, desc, children }) => (
  <div className="flex flex-wrap items-end justify-between gap-4">
    <div className="min-w-0">
      <h1 className="text-2xl font-extrabold tracking-tight sm:text-3xl">{title}</h1>
      {desc && <p className="mt-1.5 max-w-2xl text-sm text-slate-500">{desc}</p>}
    </div>
    {children && <div className="flex flex-wrap gap-2">{children}</div>}
  </div>
);

export const Card = ({ className = "", children, ...p }) => (
  <div className={`rounded-2xl border border-slate-200/80 bg-white ${className}`} {...p}>{children}</div>
);

export const Empty = ({ children, testId = "empty-state" }) => (
  <div className="rounded-2xl border border-dashed border-slate-300 p-10 text-center text-sm text-slate-500" data-testid={testId}>{children}</div>
);

export const Stat = ({ label, value, sub, id }) => (
  <Card className="p-5">
    <p className="text-xs font-semibold uppercase tracking-wider text-slate-500">{label}</p>
    <p className="mt-2 font-heading text-3xl font-extrabold tracking-tight" data-testid={`stat-${id}`}>{value}</p>
    {sub && <p className="mt-1 text-xs text-slate-500">{sub}</p>}
  </Card>
);

export const IntegrationBadge = ({ status }) => {
  const { L } = useApp();
  const map = {
    active: ["bg-emerald-50 text-emerald-700", L("Aktif", "Active")],
    limited: ["bg-amber-50 text-amber-800", L("Terhad", "Limited")],
    not_configured: ["bg-slate-100 text-slate-600", L("Belum dikonfigurasi", "Not configured")],
  };
  const [cls, label] = map[status] || map.not_configured;
  return <span className={`rounded-full px-2.5 py-1 text-xs font-semibold ${cls}`} data-testid={`integration-status-${status}`}>{label}</span>;
};
